import React, { useState } from 'react';
import Button from '../../../components/Buttons/Button';
import DateTimePicker from '../../../components/Textfields/DateTimePicker';
import AutoCompleteCorrespondent from '../../../components/AutoComplete/AutoCompleteCorrespondent';
import AutoCompleteAccountNo from '../../../components/AutoComplete/AutoCompleteAccountNo';
import AutoCompleteAccountName from '../../../components/AutoComplete/AutoCompleteAccountName';
import AutoCompleteMasterAccountNo from '../../../components/AutoComplete/AutoCompleteMasterAccountNo';
import AutoCompleteBranch from '../../../components/AutoComplete/AutoCompleteBranch';
import AutoCompleteRep from '../../../components/AutoComplete/AutoCompleteRep';
import Text from '../../../components/Typography/Text';
import {
  notifyInfo,
  notifyError,
  notifyWarning,
} from '../../../components/Messages/Notification';
import { listBalance } from '../../../services/BalanceService';
import { getSystemDate } from '../../../services/ProfileService';
import QueryParam from '../../../services/QueryParamService';
import {
  CustomBodyRenderCurrencyLeft,
  CustomBodyRenderAlign,
} from '../../../components/Table/CustomBodyRender';
import Table, { columnType } from '../../../components/ClearingTable/Table';
import { formatPbDate } from '../../../lib/fmt';
import { formatCurrencySymbol } from '../../../lib/fmt2';
import SelectSystemCode from '../../../components/Dropdown/SelectSystemCode';

export default function Balance() {
  const [lockTable, setLockTable] = React.useState(true);
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [footerData, setFooterData] = useState({});
  const [pagination, setPagination] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [searchDataCsv, setSearchDataCsv] = React.useState([]);
  const [previousRows, setPreviousRows] = useState(0);
  const [searchData, setSearchData] = React.useState(
    QueryParam.get({
      fromDate: '',
      toDate: '',
      correspondent: '',
      branch: '',
      accountNo: '',
      masterAccountNo: '',
      rep: '',
      accountName: '',
      dateType: 'Trade and Settle',
    })
  );

  const columns = [
    {
      name: 'dateType',
      label: 'Date Type',
    },
    {
      // Already converted to string in handlesearch
      name: 'date',
      label: 'Date',
    },
    {
      name: 'correspondent',
      label: 'Correspondent',
    },
    {
      name: 'branch',
      label: 'Branch',
    },
    {
      name: 'accountNo',
      label: 'Account No',
    },
    {
      name: 'rep',
      label: 'Rep',
    },
    {
      name: 'masterAccountNo',
      label: 'Master Account No',
    },
    {
      name: 'accountName',
      label: 'Account Name',
    },
    {
      name: 'accountStatus',
      label: 'Account Status',
    },
    {
      name: 'tdCashBalance',
      label: 'TD Cash Balance',
      type: columnType.amount,
    },
    {
      name: 'tdLongMarketValue',
      label: 'TD Long Market Value',
      type: columnType.amount,
    },
    {
      name: 'tdShortMarketValue',
      label: 'TD Short Market Value',
      type: columnType.amount,
    },
    {
      name: 'tdEquity',
      label: 'TD Equity',
      type: columnType.amount,
    },
    {
      name: 'tdAdjustedBalance',
      label: 'TD Adjusted Balance',
      type: columnType.amount,
    },
    {
      name: 'sdCashBalance',
      label: 'SD Cash Balance',
      type: columnType.amount,
    },
    {
      name: 'sdLongMarketValue',
      label: 'SD Long Market Value',
      type: columnType.amount,
    },
    {
      name: 'sdShortMarketValue',
      label: 'SD Short Market Value',
      type: columnType.amount,
    },
    {
      name: 'sdEquity',
      label: 'SD Equity',
      type: columnType.amount,
    },
    {
      name: 'sdAdjustedBalance',
      label: 'SD Adjusted Balance',
      type: columnType.amount,
    },
    {
      name: 'a-selectAll',
      label: 'Select All',
      options: {
        display: true,
        print: false,
        download: false,
        filter: false,
        setCellHeaderProps: () => ({
          style: {
            width: '0px',
            display: 'table-cell',
            padding: 0,
            pointerEvents: 'none',
            fontSize: 0,
          },
        }),
      },
    },
  ];

  const options = {
    selectableRows: 'none',
    responsive: 'standard',
    serverSide: 'true',
  };

  const init = async () => {
    const searchParameters = localStorage.getItem('search_data');

    const {
      fromDate,
      toDate,
      correspondent,
      branch,
      accountNo,
      masterAccountNo,
      rep,
      accountName,
    } = searchParameters ? JSON.parse(searchParameters) : searchData;

    const systemDate = await getSystemDate();

    setSearchData({
      ...searchData,
      fromDate: fromDate ? fromDate : systemDate,
      toDate: toDate ? toDate : systemDate,
      correspondent: correspondent ? correspondent : '',
      branch: branch ? branch : '',
      accountNo: accountNo ? accountNo : '',
      masterAccountNo: masterAccountNo ? masterAccountNo : '',
      rep: rep ? rep : '',
      accountName: accountName ? accountName : '',
    });
  };

  React.useEffect(() => {
    init();
    // eslint-disable-next-line
  }, []);

  const handleSearchDataChange = (e) => {
    const input = e.currentTarget.name ? e.currentTarget : e.target;

    setSearchData({ ...searchData, [input.name]: input.value });
  };

  const handleSearch = async (paginationChange) => {
    let valid = true;

    if (!searchData.fromDate) {
      notifyWarning('From Date is required.');
      valid = false;
    }

    if (!searchData.toDate) {
      notifyWarning('To Date is required.');
      valid = false;
    }

    if (!valid) {
      return;
    }

    try {
      setLoading(true);
      if (paginationChange !== true) {
        setLockTable(false);
      }
      if (paginationChange === true) {
        if (lockTable === true) {
          return;
        }
      }

      QueryParam.set(searchData);

      // localStorage.setItem('search_data', JSON.stringify(searchData))

      // const data = await listBalance(searchData)

      // let rowsCopy = data.balancesList;

      // const rowsCopyOutput = rowsCopy.map((data) => {
      //   let tempDate = formatPbDate(data.date);
      //   data.date = tempDate

      //   return data;
      // })

      // setRows(rowsCopyOutput)

      // notifyInfo(
      //   data.balancesList.length > 0
      //     ? data.balancesList.length + ' search result(s)'
      //     : 'No records found.',
      // )
      let paginationCopy = {
        ...pagination,
        reload: false,
        pageNo: paginationChange === true ? pagination.pageNo : 0,
        rowsPerPage: pagination.rowsPerPage || 100,
      };

      if (previousRows !== 0) {
        if (previousRows < pagination.rowsPerPage * pagination.pageNo) {
          paginationCopy.pageNo = 0;
        }
      }
      if (paginationChange !== true) {
        paginationCopy.filterNames = [];
        paginationCopy.filterValues = [];
      }

      const data = await listBalance(searchData, paginationCopy);

      let rowsCopy = data.balancesList;

      const rowsCopyOutput = rowsCopy.map((data) => {
        let tempDate = formatPbDate(data.date);
        data.date = tempDate;

        return data;
      });

      setSearchDataCsv(searchData);
      setPreviousRows(data.summary.totalRows);
      setTotalRows(data.summary.totalRows);

      paginationCopy.count = data.summary.totalRows;
      setPagination(paginationCopy);
      setRows(rowsCopyOutput);

      if (paginationChange !== true) {
        notifyInfo(data.summary.totalRows + ' search results.');
      }
      console.log(data.summary.tdEquity);
      setFooterData({
        tdCashBalance: formatCurrencySymbol(data.summary.tdCashBalance),
        tdLongMarketValue: formatCurrencySymbol(data.summary.tdLongMarketValue),
        tdShortMarketValue: formatCurrencySymbol(data.summary.tdShortMarketValue),
        tdEquity: formatCurrencySymbol(data.summary.tdEquity),
        tdAdjustedBalance: formatCurrencySymbol(data.summary.tdAdjustedBalance),
        sdCashBalance: formatCurrencySymbol(data.summary.sdCashBalance),
        sdLongMarketValue: formatCurrencySymbol(data.summary.sdLongMarketValue),
        sdShortMarketValue: formatCurrencySymbol(data.summary.sdShortMarketValue),
        sdEquity: formatCurrencySymbol(data.summary.sdEquity),
        sdAdjustedBalance: formatCurrencySymbol(data.summary.sdAdjustedBalance),
      });
    } catch (error) {
      setLoading(false);
      notifyError(error.message);
      console.log(error);
      return;
    } finally {
      setLoading(false);
    }
  };

  const getCsvData = async () => {
    if (lockTable === true) {
      return [];
    }
    let paginationCopy = {
      ...pagination,
      reload: false,
      pageNo: 0,
      rowsPerPage: totalRows,
    };

    const data = await listBalance(searchDataCsv, paginationCopy);
    // return data.balancesList;

    const rows = data.balancesList.map((data) => ({
      ...data,
      date: formatPbDate(data.date),
    }));
    console.log(rows);
    return rows;
  };

  return (
    <form className="page-c">
      <div className="search-c">
        <div className="grd-row nm">
          <div className="grd-cell">
            <Text mt={8} variant="h1" label="Balance" />
          </div>
          <div className="grd-cell-none">
            <Button
              disabled={loading}
              loading={loading}
              type="search"
              label={loading ? 'Searching...' : 'Search'}
              onClick={handleSearch}
            />
          </div>
        </div>
        <div className="grd-row">
          <div className="grd-cell">
            <SelectSystemCode
              name="dateType"
              label="Date Type"
              type="Date Type"
              subType="Position Report"
              disableBlank
              value={searchData.dateType}
              onChange={handleSearchDataChange}
            ></SelectSystemCode>
          </div>
          <div className="grd-cell">
            <DateTimePicker
              type="date"
              name="fromDate"
              label="From Date"
              value={searchData.fromDate}
              onChange={handleSearchDataChange}
              required={true}
              inputProps={{ max: searchData.toDate }}
            />
          </div>
          <div className="grd-cell">
            <DateTimePicker
              type="date"
              name="toDate"
              label="To Date"
              value={searchData.toDate}
              onChange={handleSearchDataChange}
              required={true}
              inputProps={{ min: searchData.fromDate }}
            />
          </div>
          <div className="grd-cell">
            <AutoCompleteCorrespondent
              name="correspondent"
              value={searchData.correspondent}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell">
            <AutoCompleteBranch
              name="branch"
              value={searchData.branch}
              correspondent={searchData.correspondent}
              onChange={handleSearchDataChange}
            />
          </div>
        </div>
        <div className="grd-row">
          <div className="grd-cell">
            <AutoCompleteAccountNo
              name="accountNo"
              value={searchData.accountNo}
              correspondent={searchData.correspondent}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell">
            <AutoCompleteMasterAccountNo
              name="masterAccountNo"
              value={searchData.masterAccountNo}
              correspondent={searchData.correspondent}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell">
            <AutoCompleteRep
              name="rep"
              value={searchData.rep}
              correspondent={searchData.correspondent}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell">
            <AutoCompleteAccountName
              name="accountName"
              value={searchData.accountName}
              correspondent={searchData.correspondent}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell"></div>
        </div>
      </div>
      <div className="mt-20">
        <Table
          title={'Balance'}
          data={rows}
          columns={columns}
          options={options}
          footerData={footerData}
          onSearch={handleSearch}
          pagination={pagination}
          setPagination={setPagination}
          getCsvData={getCsvData}
          //additionalCell={isNotMovable ? false : true}
        />
      </div>
    </form>
  );
}
